import React, {Component} from 'react';


class PaymentSuccessful extends Component {
  
  constructor() {
    super()

    if (localStorage.getItem('sessionId') === null) {
      window.location.reload(false);
    }

    
  }

  


  componentDidMount() {
    document.getElementById("root").scrollIntoView();
  }

  componentDidUpdate = (prevProps) => {
    
     document.getElementById("root").scrollIntoView();
  };
  
  render(){
  
  
 

  return (
  <section id="booking" style={{ backgroundColor: "#ffffff" }}>
  <div className="container">
   <div className="row">
            <div className="col-lg-12 col-md-12 mx-auto" style={{ marginLeft: "0px", paddingLeft: "0px", marginRight: "0px", paddingRight: "0px"  }}>
              
                
                  
                    <div className="row mb-2 d-flex justify-content-center">  
                      <div className="col-lg-6 col-lg-auto mb-6">

                        <div className="card shadow mb-3">
                          <div className="card-header bg-dark text-white pb-1">
                            <h4><i className="fas fa-shopping-cart"></i> Payment</h4>
                          </div>
                          <div className="card-body">
                            <div style={{ height: "50px" }}></div>    
                            <center>
                              <div className="badge badge-success" style={{ fontSize: "20px" }}><i className="fas fa-check"></i> Payment has been paid</div>
                              <div className="mt-4">Thank you for your purchase</div>
                            </center>
                            <div style={{ height: "50px" }}></div>    
                          </div>
                        </div>
                      </div>
                    </div>

                
              
            </div>
   </div>
 </div>
 </section>

      )
  }
  
}

export default PaymentSuccessful;